import { Input as UiInput, InputProps as UiInputProps } from "@heroui/react";
import { Controller, FieldPath, FieldValues, useFormContext } from "react-hook-form";

export interface InputProps<T extends FieldValues> extends UiInputProps {
	name: FieldPath<T>;
}

export function Input<T extends FieldValues>(props: InputProps<T>) {
	const { control } = useFormContext();
	return (
		<Controller
			control={control}
			name={props.name}
			render={({ fieldState, field }) => {
				const { ...rest } = field;

				return (
					<UiInput
						{...props}
						{...rest}
						value={
							props.type === "date" && field.value
								? new Date(field.value).toISOString().slice(0, 10)
								: props.type === "number"
								? field.value ?? ""
								: field.value ?? ""
						}
						onChange={(e) => {
							let value: string | number| undefined = e.target.value;
							if (props.type === "date") {
								value = value ? new Date(value).getTime() : value;
							} else if (props.type === "number") {
								value = value === "" ? undefined : Number(value);
							}
							field.onChange(value);
						}}
						errorMessage={fieldState?.error?.message}
						isInvalid={!!fieldState.invalid}
						className="text-start"
					/>
				);
			}}
		/>
	);
}
